import { Delete } from '../helpers';

type DeleteSessionPayload = {
  sessionID: number;
  eventUuid: string;
};

const DeleteSession = ({ sessionID, eventUuid }: DeleteSessionPayload): Promise<{ session: number }> => {
  return Delete({
    path: '/v3/admin/events/session',
    body: { sessionID, eventUuid },
  });
};

export default DeleteSession;
